export const getTextFieldValue = (value, textInputFormatter) => {
    if (!textInputFormatter) {
        return typeof value === 'number' ? String(value) : value.join(' – ');
    }
    return typeof value === 'number' ? textInputFormatter(value) : value.map(textInputFormatter).join(' – ');
};
